import { TAGS, api } from "../../api"
import { balanceEndpoints } from "../balanceAPI/balance.api"
import { IGift, INyGiftMyBehavior } from "./types"

const basePath = "/apparels/ny-gift"

export const nyGiftApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.NY_GIFT]
})

export const nyGiftEndpoints = nyGiftApi.injectEndpoints({
  endpoints: (builder) => ({
    getNyGiftMyBehavior: builder.query<INyGiftMyBehavior, void>({
      query: () => {
        return {
          url: `${basePath}/my-behavior`,
          method: "GET"
        }
      },
      providesTags: () => [{ type: TAGS.NY_GIFT, id: `MY_BEHAVIOR` }]
    }),
    claimNyGift: builder.mutation<IGift, string>({
      query: (giftId: string) => {
        return {
          url: `${basePath}/take/${giftId}`,
          method: "PATCH"
        }
      },
      invalidatesTags: () => [{ type: TAGS.NY_GIFT, id: `MY_BEHAVIOR` }],
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        try {
          const { data } = await queryFulfilled

          const { currency, amount } = data
          if (!currency || !amount) return

          dispatch?.(
            balanceEndpoints.util.updateQueryData(
              "getBalance",
              undefined,
              (draft) => {
                draft[currency] = draft[currency] + amount
              }
            )
          )
        } catch (error) {
          console.error(error)
        }
      }
    })
  })
})

export const { useGetNyGiftMyBehaviorQuery, useClaimNyGiftMutation } =
  nyGiftEndpoints
